export const aciChangeArrow = {
    iconName: 'change-arrow',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M4.945 6.433a.56.56 0 00-.16.06c-.037.023-.666.643-1.399 1.377C2.3 8.96 2.05 9.221 2.026 9.29a.578.578 0 00.034.432c.068.125 2.637 2.7 2.75 2.757.1.05.28.065.398.032a.624.624 0 00.339-.302.681.681 0 00.036-.21c0-.23-.014-.249-.923-1.161l-.833-.835h4.782c4.586-.001 4.787-.003 4.869-.04a.585.585 0 00.268-.268.688.688 0 00.01-.423.644.644 0 00-.255-.275l-.088-.047-4.793-.005-4.794-.006.841-.845c.538-.54.855-.874.878-.925a.617.617 0 00-.012-.453.53.53 0 00-.588-.283zm13.819 5.062a.684.684 0 00-.312.299.682.682 0 00-.036.21c0 .23.014.248.924 1.16l.832.836H15.39c-4.586 0-4.786.002-4.868.04a.584.584 0 00-.268.267.688.688 0 00-.011.423c.042.1.154.221.256.275l.087.047 4.793.005 4.794.006-.841.845c-.538.54-.855.874-.878.925a.617.617 0 00.012.454.506.506 0 00.464.29c.242.002.173.061 1.634-1.395 1.026-1.022 1.358-1.365 1.391-1.438a.539.539 0 00-.015-.463c-.07-.127-2.637-2.7-2.754-2.759a.768.768 0 00-.422-.027z',
                fill: 'currentColor',
            },
        },
    },
};
